import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const CondicionesPago = ({ facturaElectronica }) => {
    if (!facturaElectronica.CondicionesDePago) return null;

    return (
        <Row className="mb-2">
            <Col md={12}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '0.95em',
                    background: '#f5f5f5',
                    border: '1px solid #ddd',
                    borderRadius: 4,
                    padding: '2px 4px',
                    marginBottom: 4
                }}>
                    <span style={{ fontWeight: 'bold', color: 'red', marginRight: 8 }}>
                        CONDICIONES:
                    </span>
                    <span style={{ fontWeight: 'bold', color: 'red' }}>
                        {facturaElectronica.CondicionesDePago}
                    </span>
                </div>
            </Col>
        </Row>
    );
};

CondicionesPago.propTypes = {
    facturaElectronica: PropTypes.object
};

export default CondicionesPago;